<template>
  <div>
    <div class="row mb-5">
      <span class="display-4 col-12">
        {{ organization.name }} - {{ $t("ORGANIZATIONS.AUTHORIZATIONS") }}
      </span>
    </div>
    <permissions-table :permissionsData="organization.activePermissions" />
  </div>
</template>

<script>
import PermissionsTable from "@/components/PermissionsTable.vue";

export default {
  name: "organization-view-authorizations",

  components: { PermissionsTable },

  props: ["organization"],

  data() {
    return {};
  },

  computed: {},

  created() {},

  methods: {},

  mounted() {},

  watch: {
    organization(organization) {},
  },
};
</script>
